import { ConstantContactCustomField } from "./constant-contact-custom-field";
import { ConstantContactEmailAddressPut } from "./constant-contact-email-address-put";
import { ConstantContactPhoneNumber } from "./constant-contact-phone-number";
import { ConstantContactPhoneNumberPut } from "./constant-contact-phone-number-put";
import { ConstantContactStreetAddressPut } from "./constant-contact-street-address-put";

export class ConstantContactContactPutRequest {

    constructor(
        public emailAddress: ConstantContactEmailAddressPut,
        public firstName: string,
        public lastName: string,
        public companyName: string,
        public birthdayMonth: number,
        public birthdayDay: number,
        public anniversary: string,
        public updateSource: string,
        public customFields: ConstantContactCustomField[],
        public phoneNumbers: ConstantContactPhoneNumberPut[],
        public streetAddresses: ConstantContactStreetAddressPut[],
        public listMemberships: string[],
        public taggings: string[]
    ){}
}
